// A lightweight, framework-agnostic registry for micro-frontends/widgets
export class ExtensionRegistry {
  private static widgets = new Map<string, any>();

  static registerWidget(id: string, component: any) {
    this.widgets.set(id, component);
  }

  static getWidget<T = any>(id: string): T | null {
    return this.widgets.get(id) as T || null;
  }
}

// Standardized Kernel Events for Kanban
export const KERNEL_EVENTS = {
  KANBAN_TASK_UPDATE: 'kanban:task:update',
  KANBAN_TASK_CREATED: 'kanban:task:created',
  KANBAN_REQUEST_TASKS: 'kanban:request:tasks',
} as const;
